import type { HowItWorksProps } from "./HowItWorks.types";
import { HowItWorks5StepsDetailed, cardsDetailed5StepsConfig } from "./HowItWorks5StepsDetailed";

export const HOW_IT_WORKS_STATUS_EVENT_UA = ["clicked", "HowItWorks", "HowItWorksCTA"] as const;
export const HOW_IT_WORKS_STATUS_EVENT = {
  event: "cta_click",
  label: "how_it_works_CTA",
  placement: "how_it_works",
} as const;

export const howItWorksExperimentVariationIds = [2245225633349719, 8629836215200260, 1401985300755859, 1982834183995948];

export const howItWorksConfig: HowItWorksProps = {
  preheader: "How it works",
  title: "Compensation in 5 steps",
  cards: <HowItWorks5StepsDetailed cards={cardsDetailed5StepsConfig} />,
  buttonText: "Get Compensation Now",
  uaEvent: HOW_IT_WORKS_STATUS_EVENT_UA,
  gaEvent: HOW_IT_WORKS_STATUS_EVENT,
};
